/**
 * @class
 */
import Base from 'netxcore@netx/core/lib/netx-view';

import ActionsIconInlineTemplate from '@netx/core-app/templates/menuView-actionIconsInline.html';
import AssetDetailActionsTemplate from '@netx/core-app/templates/menuView-assetDetailActions.html';
import ContextTemplate from '@netx/core-app/templates/menuView-context.html';
import HeaderActionsTemplate from '@netx/core-app/templates/menuView-headerActions.html';
import ListHeaderActionsTemplate from '@netx/core-app/templates/menuView-listHeaderActions.html';
import PodActionsTemplate from '@netx/core-app/templates/menuView-podActions.html';
import {Menus} from '@netx/core/legacyMenuManager';

// currently these are the only menu views that can be used
// but themes can override the templates
const MenuTemplates = {
	actionIconsInline: ActionsIconInlineTemplate,
	assetDetailActions: AssetDetailActionsTemplate,
	context: ContextTemplate,
	headerActions: HeaderActionsTemplate,
	listHeaderActions: ListHeaderActionsTemplate,
	podActions: PodActionsTemplate,
};

import {icon} from '@fortawesome/fontawesome-svg-core';

export class View extends Base {
	/** @override */
	constructor(opts = {}) {
		super(opts);

		this.icons = opts.icons || {};
	}

	/** @override */
	preRender() {
		Object.assign(this.templateVars, {icons: this.icons});

		super.preRender();
	}

	/** @method */
	initializedIcons() {
		// All icons in this view have been installed
	}

	/**
	 * Material menus
	 * @override
	 */
	insertContextMenu(menuName, e) {
		const menuOptions = {
			className: 'context-menu mdc-menu-surface--anchor',
			model: this.model,
			collection: this.menuCollection || this.collection,
			context: true,
			menu: Menus[menuName],
			removeOnHide: true,
			materialMenus: {
				autoOpen: true,
			},
		};

		// Look for custom template
		const templateName = (this.$el.attr('data-nx-template') || '').replace(
			'menuView-',
			'',
		);
		if (templateName != null) {
			menuOptions.template = MenuTemplates[templateName];
		}

		// Menu view type
		const menuView = (this.menuView = new Netx.Views.MenuView(menuOptions));
		menuView.el.style.top = e.pageY + 'px';
		menuView.el.style.left = e.pageX + 'px';
		document.body.appendChild(menuView.el);
		menuView.render();

		// iOS safari has some real issues
		// if we do not do something here the menu will either hide immediately
		// or an action that is now beneath your finger will fire
		if (/iphone|ipad|ipod/i.test(navigator.userAgent)) {
			document.body.style.pointerEvents = 'none';
			_.delay(() => {
				document.body.style.pointerEvents = 'initial';
			}, 300);
		}
	}

	/** @override */
	remove() {
		delete this.icons;
		super.remove();
	}

	/**
	 * Manually trigger a tooltip on any element in this view
	 * @method
	 * @param {string|function} message Message
	 * @param {element} $el Element to apply tooltip
	 * @param {object} options Tooltip options
	 */
	showTooltip(message, $el, options = {}) {
		message = message || '';

		if (!$el) {
			console.warn('`this.tooltip` requires an element');
			return;
		}

		// Can only do one tooltip at a time per element
		if ($el.data('bs.tooltip')) {
			return;
		}

		// Backup original title
		const originalTitle = $el.attr('title');
		$el.attr(
			'title',
			_.isFunction(message) ? message.apply(this, $el) : message,
		);

		// Support for custom classes on tooltip
		if (options.className) {
			const className = _.isFunction(options.className)
				? options.className.apply(this, $el)
				: options.className;
			if (options.template) {
				options.template = $(options.template).addClass(className)[0].outerHTML;
			} else {
				// Default template with class added
				options.template = `<div class="tooltip ${className}" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>`;
			}
		}

		// Initialize tooltip
		return this.Plugins.Initialize('manualTooltips', $el, options).then(
			(instances) => {
				if (!instances) {
					console.warn(
						'`this.tooltip` instances were not returned from initialize',
					);
					return;
				}
				const instance = instances[0];
				if (!instance) return;

				// Listen once for shown
				$el.one('shown.bs.tooltip', () => {
					_.delay(() => {
						// Listen once for hidden
						$el.one('hidden.bs.tooltip', () => {
							// Cleanup
							this.Plugins.Destroy('manualTooltips', $el);
							originalTitle && $el.attr('title', originalTitle);
						});
						// Hide
						instance.hide();
					}, 3000);
				});
				// Show
				instance.show();
			},
		);
	}

	/**
	 * @method
	 * @static
	 */
	static initializeIcons(icons, opts) {
		const iconOpts = {classes: ['fa-fw'], ...opts};
		Object.entries(icons).map(([name, faIcon]) => {
			icons[name] = icon(faIcon, iconOpts).html;
		});
		return icons;
	}
}

export default View;
